import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import MDButton from "components/MDButton";

const DeleteButton = ({ loading, disabled, children, startIcon, ...rest }) => (
  <MDButton
    variant="contained"
    color="error"
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
    {...rest}
  >
    {children}
  </MDButton>
);

DeleteButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  startIcon: PropTypes.node,
};

DeleteButton.defaultProps = {
  loading: false,
  disabled: false,
  startIcon: null,
};

export default DeleteButton;
